import { createSlice } from '@reduxjs/toolkit';

// Set the initial state values of the state object that this slice will manage
const INITIAL_STATE = {
  isGetUsersLicensesInProgress: false,
  isGetUsersLicensesSuccess: false,
  usersLicenses: [],
  usersLicensesErrorMsg: '',

  isGetUsersRenewableLicensesInProgress: false,
  isGetUsersRenewableLicensesSuccess: false,
  usersRenewableLicenses: [],
  usersRenewableLicensesErrorMsg: '',

  isGetUsersTaxableLicensesInProgress: false,
  isGetUsersTaxableLicensesSuccess: false,
  usersTaxableLicenses: [],
  usersTaxableLicensesErrorMsg: '',
};

// Define the slice and generate actions, reducers with createSlice
export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: INITIAL_STATE,
  reducers: {
    usersLicensesStarted: (state) => {
      state.isGetUsersLicensesInProgress = true;
      state.isGetUsersLicensesSuccess = false;
      state.usersLicensesErrorMsg = '';
    },
    usersLicensesSucceeded: (state, action) => {
      state.isGetUsersLicensesInProgress = false;
      state.isGetUsersLicensesSuccess = true;
      state.usersLicenses = action.payload;
      state.usersLicensesErrorMsg = '';
    },
    usersLicensesFailure: (state, action) => {
      state.isGetUsersLicensesInProgress = false;
      state.isGetUsersLicensesSuccess = false;
      state.usersLicenses = [];
      state.usersLicensesErrorMsg = action.payload;
    },

    usersRenewableLicensesStarted: (state) => {
      state.isGetUsersRenewableLicensesInProgress = true;
      state.isGetUsersRenewableLicensesSuccess = false;
      state.usersRenewableLicensesErrorMsg = '';
    },
    usersRenewableLicensesSucceeded: (state, action) => {
      state.isGetUsersRenewableLicensesInProgress = false;
      state.isGetUsersRenewableLicensesSuccess = true;
      state.usersRenewableLicenses = action.payload;
      state.usersRenewableLicensesErrorMsg = '';
    },
    usersRenewableLicensesFailure: (state, action) => {
      state.isGetUsersRenewableLicensesInProgress = false;
      state.isGetUsersRenewableLicensesSuccess = false;
      state.usersRenewableLicenses = [];
      state.usersRenewableLicensesErrorMsg = action.payload;
    },

    usersTaxableLicensesStarted: (state) => {
      state.isGetUsersTaxableLicensesInProgress = true;
      state.isGetUsersTaxableLicensesSuccess = false;
      state.usersTaxableLicensesErrorMsg = '';
    },
    usersTaxableLicensesSucceeded: (state, action) => {
      state.isGetUsersTaxableLicensesInProgress = false;
      state.isGetUsersTaxableLicensesSuccess = true;
      state.usersTaxableLicenses = action.payload;
      state.usersTaxableLicensesErrorMsg = '';
    },
    usersTaxableLicensesFailure: (state, action) => {
      state.isGetUsersTaxableLicensesInProgress = false;
      state.isGetUsersTaxableLicensesSuccess = false;
      state.usersTaxableLicenses = [];
      state.usersTaxableLicensesErrorMsg = action.payload;
    },

    resetDashboardState: (state) => INITIAL_STATE,
  },
});

// Export actions that were generated by createSlice
export const {
  usersLicensesStarted,
  usersLicensesSucceeded,
  usersLicensesFailure,
  usersRenewableLicensesStarted,
  usersRenewableLicensesSucceeded,
  usersRenewableLicensesFailure,
  usersTaxableLicensesStarted,
  usersTaxableLicensesSucceeded,
  usersTaxableLicensesFailure,
  resetDashboardState,
} = dashboardSlice.actions;

// Export combined reducer that was generated by createSlice
// (this is a single reducer which is a combination of all reducers in the slice... it basically puts them in a switch statement)
export default dashboardSlice.reducer;
